export const MediaVod = () => {
  return <div id="cemboo-media-library"></div>;
};
